var exports = {
  "x": "BranchInfoBarContainer__tPnjKi",
  "$": "branchInfoBarBase__J3I4LU",
};

module.exports = exports;
